import React from "react";

export default function MusicNoteIcon() {
    return <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-ptiqhd-MuiSvgIcon-root"
                focusable="false"
                aria-hidden={true}
                viewBox="0 0 30 20"
                fill="currentColor"
                width={"1.5em"}
                height={"1.5em"}
        >
        <path
            d="M 12 3 v 10.55 c -0.59 -0.34 -1.27 -0.55 -2 -0.55 c -2.21 0 -4 1.79 -4 4 s 1.79 4 4 4 s 4 -1.79 4 -4 V 7 L 22 5 L 22 1 z m -2 16 c -1.1 0 -2 -0.9 -2 -2 s 0.9 -2 2 -2 s 2 0.9 2 2 s -0.9 2 -2 2 M 22 1 v 10.55 c -0.59 -0.34 -1.27 -0.55 -2 -0.55 c -2.21 0 -4 1.79 -4 4 s 1.79 4 4 4 s 4 -1.79 4 -4 V 4 l 0 0 V 1 z m -2 16 c -1.1 0 -2 -0.9 -2 -2 s 0.9 -2 2 -2 s 2 0.9 2 2 s -0.9 2 -2 2"></path>
    </svg>
}